<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,784.77c2,0,3.64,1.64,3.64,3.64c0,0.83-0.29,1.59-0.77,2.21l2.06,2.64c0.44-0.19,0.93-0.3,1.45-0.3
	c2,0,3.63,1.64,3.63,3.64c0,2-1.63,3.64-3.63,3.64c-2,0-3.64-1.64-3.64-3.64c0-0.83,0.29-1.59,0.77-2.2l-2.06-2.65
	c-0.44,0.19-0.93,0.3-1.44,0.3c-0.51,0-1-0.11-1.44-0.3l-2.05,2.64c0.47,0.61,0.77,1.37,0.77,2.2c0,2-1.64,3.64-3.64,3.64
	c-2,0-3.64-1.64-3.64-3.64c0-2,1.64-3.64,3.64-3.64c0.51,0,1,0.11,1.44,0.3l2.05-2.64c-0.48-0.62-0.77-1.38-0.77-2.21
	C-3.14,786.41-1.5,784.77,0.5,784.77L0.5,784.77z M-1.32,788.41c0,1.02,0.81,1.82,1.82,1.82s1.82-0.8,1.82-1.82
	c0-1.01-0.8-1.82-1.82-1.82S-1.32,787.39-1.32,788.41z M-7.68,796.59c0,1.01,0.81,1.82,1.82,1.82c1.01,0,1.82-0.8,1.82-1.82
	c0-1.02-0.8-1.82-1.82-1.82C-6.88,794.77-7.68,795.58-7.68,796.59z M5.05,796.59c0,1.01,0.81,1.82,1.82,1.82
	c1.01,0,1.82-0.8,1.82-1.82c0-1.02-0.8-1.82-1.82-1.82C5.86,794.77,5.05,795.58,5.05,796.59z"/>
</svg>

</template>